import {
  Table, Form, Upload, Checkbox, message, Button,
} from 'antd';
import { any } from 'prop-types';
import { UploadOutlined } from '@ant-design/icons';
import { globalUploadFileUrl } from '@/services/common';

export default function EquipmentExpandTable({
  data, name, type, formRef,
}) {
  const props = {
    name: 'file',
    maxCount: 1,
    accept: '.rar,.zip,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.pdf',
    action: globalUploadFileUrl,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isLt2M) {
        message.error('请上传200M以下文件!');
      }
      return isLt2M;
    },
  };
  const baseColumns = [
    { title: '设施设备名称', dataIndex: 'equipName', width: 100 },
    { title: '单位', dataIndex: 'unit', width: 60 },
    { title: '设备型号', dataIndex: 'equipType', width: 100 },
    { title: '单价(万元)', dataIndex: 'unitPrice', width: type ? 60 : 100 },
    { title: '数量', dataIndex: 'num', width: 80 },
    { title: '总额(万元)', dataIndex: 'totalAmount', width: 100 },
    { title: '省级专项资金(万元)', dataIndex: 'provincialSubsidyFunds', width: 100 },
    { title: '市县资金(万元)', dataIndex: 'cityFunding', width: 90 },
    { title: '企业自筹资金(万元)', dataIndex: 'selfFunding', width: 100 },
    { title: '其他资金(万元)', dataIndex: 'otherFunding', width: 90 },
  ];

  const finishColumns = [
    {
      title: '是否完成',
      dataIndex: 'finishFlag',
      width: 50,
      fixed: 'right',
      render: (_, __, index) => (
        <Form.Item
          name={[name, index, 'finishFlag']}
          valuePropName="checked"
          initialValue={false}
          noStyle
        >
          <Checkbox
            onChange={() => {
              formRef.validateFields([
                [name, index, 'fileList1'],
                [name, index, 'fileList2'],
              ]);
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: '支付凭证',
      dataIndex: 'fileList1',
      width: 120,
      fixed: 'right',
      ellipsis: true,
      render: (_, __, index) => (
        <Form.Item
          style={{ marginBottom: 0 }}
          name={[name, index, 'fileList1']}
          dependencies={[[name, index, 'finishFlag']]}
          rules={[
            ({ getFieldValue }) => ({
              // eslint-disable-next-line no-shadow
              validator(_, value) {
                const finished = getFieldValue([name, index, 'finishFlag']);
                if (!finished) return Promise.resolve();
                if (value && value.length > 0) return Promise.resolve();
                return Promise.reject(new Error('请上传支付凭证'));
              },
            }),
          ]}
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList}
        >
          <Upload
            {...props}
            onChange={
              ({ file }) => {
                if (file.status === 'done') {
                  message.success(`文件【${file.name}】上传成功`);
                } else if (file.status === 'error') {
                  message.error('上传失败');
                }
                formRef.validateFields([[name, index, 'fileList1']]);
              }
            }
          >
            <Button type="link" icon={<UploadOutlined />}>上传</Button>
          </Upload>
        </Form.Item>
      ),
    },
    {
      title: '工程凭证',
      dataIndex: 'fileList2',
      width: 120,
      fixed: 'right',
      ellipsis: true,
      render: (_, __, index) => (
        <Form.Item
          style={{ marginBottom: 0 }}
          name={[name, index, 'fileList2']}
          dependencies={[[name, index, 'finishFlag']]}
          rules={[
            ({ getFieldValue }) => ({
              // eslint-disable-next-line no-shadow
              validator(_, value) {
                const finished = getFieldValue([name, index, 'finishFlag']);
                if (!finished) return Promise.resolve();
                if (value && value.length > 0) return Promise.resolve();
                return Promise.reject(new Error('请上传工程凭证'));
              },
            }),
          ]}
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList}
        >
          <Upload
            {...props}
            onChange={
              ({ file }) => {
                if (file.status === 'done') {
                  message.success(`文件【${file.name}】上传成功`);
                } else if (file.status === 'error') {
                  message.error('上传失败');
                }
                formRef.validateFields([[name, index, 'fileList2']]);
              }
            }
          >
            <Button type="link" icon={<UploadOutlined />}>上传</Button>
          </Upload>
        </Form.Item>
      ),
    },
  ];

  const columns = type
    ? baseColumns.concat(finishColumns)
    : baseColumns;

  return (
    <Table
      rowKey={(row, index) => index}
      columns={columns}
      dataSource={data}
      pagination={false}
      size="small"
      bordered
    />
  );
}

EquipmentExpandTable.propTypes = {
  data: any,
  name: any,
  type: any,
  formRef: any,
};
